/**
 * 문항 카드 AI 액션 transport — 세션·SSE 없는 단발 JSON 2종.
 * 경로·본문·응답 검증은 QUESTION_CARD_AI_ENDPOINTS 가 선언하고, 여기선 엔드포인트에 묶기만 한다.
 */
import {
  callQuestionCardAiEndpoint,
  type FillOptionsRequest,
  QUESTION_CARD_AI_ENDPOINTS,
  type SimilarQuestionRequest,
} from './questionCardAiEndpoints';
import { type QuestionCardAiTransportDependencies } from './questionCardAiHttpClient';

export { QUESTION_CARD_AI_TIMEOUT_MS } from '../consts/questionCardAi.const';
export {
  type FillOptionsRequest,
  QuestionCardAiInvalidResponseError,
  type SimilarQuestionRequest,
} from './questionCardAiEndpoints';
export {
  type QuestionCardAiFetch,
  type QuestionCardAiTransportDependencies,
} from './questionCardAiHttpClient';
export {
  isQuestionCardAiHttpError,
  QuestionCardAiHttpError,
} from './questionCardAiHttpError';

export const requestSimilarQuestion = (
  request: SimilarQuestionRequest,
  dependencies?: QuestionCardAiTransportDependencies,
) =>
  callQuestionCardAiEndpoint(
    QUESTION_CARD_AI_ENDPOINTS.similar,
    request,
    dependencies,
  );

export const requestFillOptions = (
  request: FillOptionsRequest,
  dependencies?: QuestionCardAiTransportDependencies,
) =>
  callQuestionCardAiEndpoint(
    QUESTION_CARD_AI_ENDPOINTS.fill_options,
    request,
    dependencies,
  );
